<!-- REPORTS (SENIOR)-->
<div class='quick-link'>
  <a href="javascript:void(0)" (click)="submitBroker360Form();" class="external-link">
    {{ broker360Label || 'Highmark Hub' }}
    <span class="material-symbols-outlined">open_in_new</span>
  </a>
</div>